// extracted by mini-css-extract-plugin
export default {"languageSelect":"Language_languageSelect__9Z8D4","language":"Language_language__-0IpI"};